export default __webpack_public_path__ + "static/media/ohio.7922ca40.jpg";